import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { detectBrowserLanguage } from './lib/utils';

const resources = {
  en: {
    translation: {
      // Homepage
      'SWITZERLAND, GET READY FOR ZOOMIES': 'SWITZERLAND, GET READY FOR ZOOMIES',
      'The ultimate destination for unique, playful, and high-quality pet essentials. Sign up to get early access and exclusive perks!': 'The ultimate destination for unique, playful, and high-quality pet essentials. Sign up to get early access and exclusive perks!',
      'Where every pet\'s story begins with': "Where every pet's story begins with",
      'LOVE': 'LOVE',
      'WE SHIP NATIONWIDE': 'WE SHIP NATIONWIDE',
      'FREE SHIPPING ON ORDERS CHF 50+': 'FREE SHIPPING ON ORDERS CHF 50+',
      'Join 1,200+ other pet lovers on the waitlist!': 'Join 1,200+ other pet lovers on the waitlist!',
      'Email address': 'Email address',
      'JOIN THE WAITLIST': 'JOIN THE WAITLIST',
      'Thank you for joining! See you soon in the Zoomies & Co community!': 'Thank you for joining! See you soon in the Zoomies & Co community!',
      'We respect your privacy. No spam, ever.': 'We respect your privacy. No spam, ever.',
      'What is Zoomies & Co?': 'What is Zoomies & Co?',
      'Learn About Us': 'Learn About Us',
      'Where the Zoomies Begin.': 'Where the Zoomies Begin.',
      'Only The Good Stuff': 'Only The Good Stuff',
      'Tested by pets, approved by picky humans (that\'s us)': "Tested by pets, approved by picky humans (that's us)",
      'Stay Tuned': 'Stay Tuned',
      'The structural adaptation of care enables pets to thrive.': 'The structural adaptation of care enables pets to thrive.',
      'Power to Live': 'Power to Live',
      '(The power to live)': '(The power to live)',
      'We believe in the biology of love, the science of play, and the poetry of paws. Zoomies & Co is for pets who are more than cute—they\'re wild, weird, and worthy.': "We believe in the biology of love, the science of play, and the poetry of paws. Zoomies & Co is for pets who are more than cute—they're wild, weird, and worthy.",
      'Early Access': 'Early Access',
      'Launch Discounts': 'Launch Discounts',
      'Your pet shall thank you (& judge you less)': 'Your pet shall thank you (& judge you less)',
      'Don\'t miss out! Sign up for early access:': "Don't miss out! Sign up for early access:",
      'Manga': 'Manga',
      'PAWS / FANGS / LOVE': 'PAWS / FANGS / LOVE',
      'The structural adaptation of': 'The structural adaptation of',
      'care': 'care',
      'enables pets to': 'enables pets to',
      'thrive': 'thrive',
      'Discount': 'Discount',
      'Reward?': 'Reward?',
      // About Us
      'ABOUT US': 'ABOUT US',
      'Our Story': 'Our Story',
      'Our Mission': 'Our Mission',
      'Discover the passion, creativity, and love behind Zoomies & Co': 'Discover the passion, creativity, and love behind Zoomies & Co',
      'Born for the Pets Who Run the Show': 'Born for the Pets Who Run the Show',
      'Zoomies & Co was born for the pets who run the show — and the humans who happily let them. From tail-wagging tools to purr-worthy wellness, everything we curate is handpicked to feel like it came from your inner circle — not a random aisle in a mega-store.': 'Zoomies & Co was born for the pets who run the show — and the humans who happily let them. From tail-wagging tools to purr-worthy wellness, everything we curate is handpicked to feel like it came from your inner circle — not a random aisle in a mega-store.',
      'The Right Essentials': 'The Right Essentials',
      'The right essentials should feel like you never left their side.': 'The right essentials should feel like you never left their side.',
      'Every Item Whispers': 'Every Item Whispers',
      'Every item should whisper, "I see you, I love you." Like a Zoomies moment in slow motion — gentle, joyful, and full of heart.': 'Every item should whisper, "I see you, I love you." Like a Zoomies moment in slow motion — gentle, joyful, and full of heart.',
      'Your Pet\'s Joy': "Your Pet's Joy",
      'And your pet\'s joy? It\'s the most important package we\'ll ever ship.': "And your pet's joy? It's the most important package we'll ever ship.",
      'Our Values': 'Our Values',
      'Kind to All Creatures': 'Kind to All Creatures',
      'We work with partners who value quality, compassion, and care — choosing items that are gentle on paws, safe for homes, and mindful of our shared world.': 'We work with partners who value quality, compassion, and care — choosing items that are gentle on paws, safe for homes, and mindful of our shared world.',
      'Built on Love & Zoomies': 'Built on Love & Zoomies',
      'Everything we do is for that one tail wag, one happy bounce, one deep breath of "ahhh." That\'s our why — and always will be.': 'Everything we do is for that one tail wag, one happy bounce, one deep breath of "ahhh." That\'s our why — and always will be.',
      'Join Our Journey': 'Join Our Journey',
      'Be part of our story as we continue to create amazing products for pets and their humans. Sign up for early access and exclusive updates!': 'Be part of our story as we continue to create amazing products for pets and their humans. Sign up for early access and exclusive updates!',
      'Back to Homepage': 'Back to Homepage',
      'Spreading joy, one wag at a time': 'Spreading joy, one wag at a time',
      'Contact': 'Contact',
      'Email': 'Email',
      'Terms': 'Terms',
      'Privacy Policy': 'Privacy Policy',
      'Terms & Conditions': 'Terms & Conditions',
      'Impressum': 'Impressum',
    },
  },
  de: {
    translation: {
      // Homepage
      'SWITZERLAND, GET READY FOR ZOOMIES': 'SCHWEIZ, MACH DICH BEREIT FÜR ZOOMIES',
      'The ultimate destination for unique, playful, and high-quality pet essentials. Sign up to get early access and exclusive perks!': 'Das ultimative Ziel für einzigartige, verspielte und hochwertige Haustierartikel. Melde dich an, um früheren Zugang und exklusive Vorteile zu erhalten!',
      'Where every pet\'s story begins with': "Wo jede Haustiergeschichte beginnt mit",
      'LOVE': 'LIEBE',
      'WE SHIP NATIONWIDE': 'WIR LIEFERN LANDESWEIT',
      'FREE SHIPPING ON ORDERS CHF 50+': 'KOSTENLOSER VERSAND AB CHF 50',
      'Join 1,200+ other pet lovers on the waitlist!': 'Schließe dich über 1.200 anderen Haustierliebhabern auf der Warteliste an!',
      'Email address': 'E-Mail-Adresse',
      'JOIN THE WAITLIST': 'AUF DIE WARTELISTE',
      'Thank you for joining! See you soon in the Zoomies & Co community!': 'Danke fürs Eintragen! Bis bald in der Zoomies & Co Community!',
      'We respect your privacy. No spam, ever.': 'Wir respektieren deine Privatsphäre. Kein Spam, versprochen.',
      'What is Zoomies & Co?': 'Was ist Zoomies & Co?',
      'Learn About Us': 'Über uns',
      'Where the Zoomies Begin.': 'Wo die Zoomies beginnen.',
      'Only The Good Stuff': 'Nur das Beste',
      'Tested by pets, approved by picky humans (that\'s us)': 'Von Haustieren getestet, von wählerischen Menschen (uns) genehmigt',
      'Stay Tuned': 'Bleib dran',
      'The structural adaptation of care enables pets to thrive.': 'Die strukturelle Anpassung von Fürsorge lässt Haustiere gedeihen.',
      'Power to Live': 'Kraft zu leben',
      '(The power to live)': '(Die Kraft zu leben)',
      'We believe in the biology of love, the science of play, and the poetry of paws. Zoomies & Co is for pets who are more than cute—they\'re wild, weird, and worthy.': 'Wir glauben an die Biologie der Liebe, die Wissenschaft des Spiels und die Poesie der Pfoten. Zoomies & Co ist für Haustiere, die mehr als nur süß sind – sie sind wild, eigen und wertvoll.',
      'Early Access': 'Früher Zugang',
      'Launch Discounts': 'Start-Rabatte',
      'Your pet shall thank you (& judge you less)': 'Dein Haustier wird es dir danken (& dich weniger verurteilen)',
      'Don\'t miss out! Sign up for early access:': 'Nicht verpassen! Melde dich für früheren Zugang an:',
      'Manga': 'Manga',
      'PAWS / FANGS / LOVE': 'PFOTEN / FÄNGE / LIEBE',
      'The structural adaptation of': 'Die strukturelle Anpassung von',
      'care': 'Fürsorge',
      'enables pets to': 'ermöglicht Haustieren zu',
      'thrive': 'gedeihen',
      'Discount': 'Rabatt',
      'Reward?': 'Belohnung?',
      // About Us
      'ABOUT US': 'ÜBER UNS',
      'Our Story': 'Unsere Geschichte',
      'Our Mission': 'Unsere Mission',
      'Discover the passion, creativity, and love behind Zoomies & Co': 'Entdecke die Leidenschaft, Kreativität und Liebe hinter Zoomies & Co',
      'Born for the Pets Who Run the Show': 'Geboren für die Haustiere, die das Sagen haben',
      'Zoomies & Co was born for the pets who run the show — and the humans who happily let them. From tail-wagging tools to purr-worthy wellness, everything we curate is handpicked to feel like it came from your inner circle — not a random aisle in a mega-store.': 'Zoomies & Co wurde für die Haustiere geboren, die das Sagen haben – und die Menschen, die sie gerne lassen. Von schwanzwedelnden Tools bis zu schnurrwürdiger Wellness – alles, was wir auswählen, fühlt sich an, als käme es aus deinem engsten Kreis – nicht aus einem Regal eines Megastores.',
      'The Right Essentials': 'Die richtigen Essentials',
      'The right essentials should feel like you never left their side.': 'Die richtigen Essentials sollten sich anfühlen, als wärst du nie von ihrer Seite gewichen.',
      'Every Item Whispers': 'Jeder Artikel flüstert',
      'Every item should whisper, "I see you, I love you." Like a Zoomies moment in slow motion — gentle, joyful, and full of heart.': 'Jeder Artikel sollte flüstern: "Ich sehe dich, ich liebe dich." Wie ein Zoomies-Moment in Zeitlupe – sanft, freudig und voller Herz.',
      'Your Pet\'s Joy': 'Die Freude deines Haustiers',
      'And your pet\'s joy? It\'s the most important package we\'ll ever ship.': 'Und die Freude deines Haustiers? Das ist das wichtigste Paket, das wir je verschicken.',
      'Our Values': 'Unsere Werte',
      'Kind to All Creatures': 'Freundlich zu allen Lebewesen',
      'We work with partners who value quality, compassion, and care — choosing items that are gentle on paws, safe for homes, and mindful of our shared world.': 'Wir arbeiten mit Partnern, die Qualität, Mitgefühl und Fürsorge schätzen – und wählen Produkte, die sanft zu Pfoten, sicher für Zuhause und achtsam für unsere gemeinsame Welt sind.',
      'Built on Love & Zoomies': 'Gebaut auf Liebe & Zoomies',
      'Everything we do is for that one tail wag, one happy bounce, one deep breath of "ahhh." That\'s our why — and always will be.': 'Alles, was wir tun, ist für dieses eine Schwanzwedeln, einen glücklichen Sprung, einen tiefen Atemzug des "Ahhh". Das ist unser Warum – und wird es immer sein.',
      'Join Our Journey': 'Begleite unsere Reise',
      'Be part of our story as we continue to create amazing products for pets and their humans. Sign up for early access and exclusive updates!': 'Sei Teil unserer Geschichte, während wir weiterhin großartige Produkte für Haustiere und ihre Menschen schaffen. Melde dich für früheren Zugang und exklusive Updates an!',
      'Back to Homepage': 'Zurück zur Startseite',
      'Spreading joy, one wag at a time': 'Freude verbreiten, ein Schwanzwedeln nach dem anderen',
      'Contact': 'Kontakt',
      'Email': 'E-Mail',
      'Terms': 'AGB',
      'Privacy Policy': 'Datenschutzerklärung',
      'Terms & Conditions': 'Allgemeine Geschäftsbedingungen',
      'Impressum': 'Impressum',
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: detectBrowserLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n; 